import ApiUrl from "../../../configTools/api";
// Guarantees the callback fires exactly once with an array, even on failure - the page
// clears its loading flag inside it, so a dropped request must not leave a shimmer spinning.
import { apiGetList } from "../../../configTools/apiGet";
const User = JSON.parse(localStorage.getItem("user-info"));

const Get = (setValues) => {
    apiGetList(ApiUrl.LabAdmin_Doctors, (list, body)=>{
        setValues(list);
    });
}


const Post = (body,setValues,toast,toastid,reset) => {
    fetch(ApiUrl.LabAdmin_Doctors,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify(body)
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            setTimeout(() => {
              toast.update(toastid, { render: "Added", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
            Get(setValues);
            reset();
        }
        else{
            setTimeout(() => {
              toast.update(toastid, { render: data.response, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
        }
    });
}


const Put = (id,body,setValues,toast,toastid,reset) => {
    fetch(ApiUrl.LabAdmin_Doctors+"/"+id,{
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify(body)
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            setTimeout(() => {
              toast.update(toastid, { render: "Updated", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
            Get(setValues);
            reset();
        }
        else{
            setTimeout(() => {
              toast.update(toastid, { render: data.response, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
        }
    });
}

const Delete = (id,setValues,toast,toastid) => {
    fetch(ApiUrl.LabAdmin_Doctors+"/"+id,{
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            setTimeout(() => {
              toast.update(toastid, { render: "Deleted", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
            Get(setValues);
        }
        else{
            setTimeout(() => {
              toast.update(toastid, { render: data.response, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
        }
    });
}

const Functions = {Get, Post, Put, Delete};
export default Functions;